export const PERKS_DESCRIPTION_MODAL = {
    root: 'perks-description-modal',
    title: 'perks-description-modal-title',
    id: 'perks-description-modal-id',
    startsAt: 'starts-at',
    endsAt: 'ends-at',
    subtitle: 'subtitle',
    iconName: 'back-arrow',
    perkSection: 'perk-section'
};
